import { BLACK_c, BLACK_d, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 20rem;
  position: relative;
  display: flex;
  margin-bottom: 35rem;
  gap: 15rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 10rem;
    gap: 3rem;
    flex-direction: column-reverse;
    margin-bottom: 30rem;
  }
`;

export const Container1 = styled.div`
  margin-left: 8.7rem;

  & > img {
    width: 28.5rem;
    height: 61.7rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin: 0 auto;
  }
`;

export const Container3 = styled.div`
  margin-left: 3.8rem;
  display: flex;
  flex-direction: column;
  gap: 8.2rem;
  width: 45.8rem;
  padding-top: 18.5rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin: 0;
    padding: 0;
    width: 100%;
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    flex-direction: column;
    &:nth-child(1) {
      font-weight: 300;
      font-size: 1.4rem;
      line-height: 2.4rem;
      color: ${MAIN_GREEN};
    }
    &:nth-child(2) {
      font-weight: 700;
      font-size: 3.2rem;
      line-height: 5.4rem;
      display: flex;
      flex-direction: column;
    }
    &:nth-child(3) {
      font-weight: 300;
      font-size: 1.8rem;
      line-height: 3.2rem;
      color: ${BLACK_d};
      display: flex;
      flex-direction: column;
      gap: 3.2rem;
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    & > div {
      &:nth-child(2) {
        font-weight: 700;
        font-size: 2.4rem;
        line-height: 4.2rem;
        display: block;
      }

      &:nth-child(3) {
        font-weight: 300;
        font-size: 1.6rem;
        line-height: 2.8rem;
        gap: 2.8rem;
      }
    }
  }
`;

export const Design1 = styled.div`
  position: absolute;
  z-index: -999;
  width: 63.1rem;
  height: 61.7rem;
  left: 36.2rem;

  background: linear-gradient(90deg, #021106 6.1%, rgba(0, 0, 0, 0) 100%);
  transform: matrix(1, 0, 0, -1, 0, 0);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;
